import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const EASE = [0.32, 0.72, 0, 1] as const;

interface RevealProps {
  children: ReactNode;
  /** Atraso em segundos para reveals escalonados. */
  delay?: number;
  className?: string;
}

/**
 * Entrada cinematográfica ao entrar no viewport (fade-up com leve blur).
 * Anima só `transform`/`opacity`/`filter` e dispara uma única vez.
 * Respeita `prefers-reduced-motion`: nesse caso o conteúdo aparece estático.
 */
export function Reveal({ children, delay = 0, className }: RevealProps) {
  const reduzir = useReducedMotion();

  if (reduzir) {
    return <div className={className}>{children}</div>;
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 28, filter: 'blur(6px)' }}
      whileInView={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.75, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
